import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';
import { HttpService } from "../../../services/http.service";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})

export class VendorConfigService {
    baseVendorConfigURL: string;

    constructor(
        private httpService: HttpService,
        private http: HttpClient) {
        this.baseVendorConfigURL = environment.vendorUrl;
    }

    getVendorConfig(categoryId: number): Observable<any>{
        return this.httpService.getAll(`${this.baseVendorConfigURL}Vendor?categoryId=${categoryId}`);
    }

    getVendorCalendarEvents(vendorId: number, startDate: string, endDate: string): Observable<any>{
        let params = new HttpParams();
        if (vendorId !== null) {
            params = params.set('VendorUserById', vendorId);
        }
        if (startDate !== null) {
            params = params.set('startDate', startDate);
        }
        if (endDate !== null) {
            params = params.set('endDate', endDate);
        }
        //return this.httpService.getAll(`${environment.activity}/LionO360/2.0/API/CalendarEvent/CalendarView?startDate=${startDate}&endDate=${endDate}&VendorUserById=${vendorId}`);
        return this.http.get(`${environment.activity}/LionO360/2.0/API/CalendarEvent/CalendarView`, { params });
        
    }

    inactiveVendorConfig(id: number, isActive = false): Observable<any>{
        return this.httpService.update(`${this.baseVendorConfigURL}VendorOAuthRegistrationUser/InActive?id=${id}&IsActive=${isActive}`);
    }

    inactiveCalendarUser(id: number, isActive = false): Observable<any>{
        return this.httpService.update(`${this.baseVendorConfigURL}VendorOAuthRegistrationUser/SignOutCalendarUser?id=${id}&IsActive=${isActive}`);
    }

    activeInactiveVendorConfigCategory(id: number, isActive: boolean): Observable<any>{
        return this.httpService.update(`${this.baseVendorConfigURL}Vendor/ActiveCategory?id=${id}&IsActive=${isActive}`);
    }

}

